module.exports = __webpack_public_path__ + "fa42778449d99af712f0cb90abe0a9a5.webp";